import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const OutputBlockConfigSchema = z.object({
  data: z.string(),
});

export const OutputBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Output),
  config: OutputBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Any),
});

export type OutputBlock = z.infer<typeof OutputBlockSchema>;
